var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle",
    transform: "translate(-1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M11.25,1.25a10,10,0,1,0,10,10A10.008,10.008,0,0,0,11.25,1.25Zm0,18.6a8.6,8.6,0,1,1,8.6-8.6A8.615,8.615,0,0,1,11.25,19.855Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M11.948,7.25a.7.7,0,0,0-.7.7V12.6a.7.7,0,1,0,1.4,0V7.948A.7.7,0,0,0,11.948,7.25Z",
    transform: "translate(-1.948 1.122)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M11.93,15a.926.926,0,0,0-.353.074,1.074,1.074,0,0,0-.307.2.96.96,0,0,0-.2.307.877.877,0,0,0,0,.707.839.839,0,0,0,.5.5.93.93,0,0,0,.707,0,.839.839,0,0,0,.5-.5.877.877,0,0,0,0-.707.96.96,0,0,0-.2-.307,1.074,1.074,0,0,0-.307-.2A.926.926,0,0,0,11.93,15Z",
    transform: "translate(-1.93 -9.656)",
    fill: "#292d32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.ccd053776c947c0da442d09fc046c5f3.svg";
export { ForwardRef as ReactComponent };